import React from "react";
import { useNavigate } from "react-router-dom"; // ✅ Import useNavigate
import Footer from "../components/common/Footer";

const Desktop4 = () => {
    const navigate = useNavigate(); // ✅ Initialize navigate function

    return (
        <div className="bg-[#f9f9f9] w-full overflow-x-hidden">
            {/* Hero Section */}
            <section className="relative bg-gradient-to-b from-[#06010A] to-[#260345] text-white flex flex-col md:flex-row items-center justify-between px-8 md:px-16 lg:px-24 py-20 overflow-hidden">
                {/* Decorative Ellipses */}
                <div className="absolute inset-0 overflow-hidden">
                    <div className="absolute w-[400px] h-[400px] bg-[#7B3FE4]/40 rounded-full blur-3xl top-[-100px] left-[-100px]" />
                    <div className="absolute w-[350px] h-[350px] bg-[#E6C1FF]/30 rounded-full blur-3xl bottom-[-150px] right-[-100px]" />
                </div>

                {/* Subtle Rectangle Background */}


                {/* Left Content */}
                <div className="relative z-10 max-w-xl">
                    <h3 className="text-lg text-[#ffffffbf] mb-3">AI Resume Builder</h3>
                    <h1 className="text-4xl md:text-5xl font-semibold leading-tight mb-6">
                        Build a job-winning resume as easily as sending a message
                    </h1>
                    <p className="text-gray-200 mb-8 text-base md:text-lg">
                        Turn your work experience, skills, and achievements into a clean,
                        recruiter-friendly resume that’s optimized for Applicant Tracking
                        Systems (ATS).
                    </p>

                    {/* ✅ Get Started Button linked to /auth */}
                    <button
                        onClick={() => navigate("/auth")}
                        className="bg-[#ffc403] text-black font-bold px-6 py-3 rounded-xl hover:bg-[#e6b800] transition"
                    >
                        Get Started
                    </button>
                </div>

                {/* Right Image */}
                <div className="relative z-10 mt-12 md:mt-0">
                    <img
                        src="https://c.animaapp.com/mge1sasxzrNszH/img/image-60.png"
                        alt="Resume Preview"
                        className="w-[350px] md:w-[450px] object-contain"
                    />
                </div>
            </section>

            {/* Feature Section */}
            <section className="bg-[#f9f9f9] py-20 px-6 md:px-16 lg:px-24 text-[#22033c]">
                <h2 className="text-3xl md:text-4xl font-semibold text-center mb-4">
                    Build smarter, faster, and more effective resumes
                </h2>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-12 mt-12 max-w-6xl mx-auto">
                    {[
                        "Smart Suggestions",
                        "Instant Formatting",
                        "ATS Optimization",
                        "Export in Clicks",
                        "Multiple Styles & Templates",
                        "One Profile, Many Resumes",
                    ].map((title, index) => (
                        <div
                            key={index}
                            className="flex flex-col items-center text-center space-y-3"
                        >
                            <h3 className="font-semibold text-lg md:text-xl">{title}</h3>
                            <p className="text-base text-[#22033c]/80">
                                Get tailored recommendations to highlight your top skills and
                                achievements.
                            </p>
                        </div>
                    ))}
                </div>
            </section>

            {/* Template Showcase Section */}
            <section className="bg-[#f9f9f9] py-20 px-6 md:px-16 lg:px-24 text-center">
                <h2 className="text-3xl md:text-4xl font-semibold text-[#22033c] mb-4">
                    Choose from templates that match your style
                </h2>
                <p className="text-[#22033c]/80 text-lg mb-10 max-w-2xl mx-auto">
                    From modern and creative to professional and minimal — pick a design
                    that fits your career goals.
                </p>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-6xl mx-auto">
                    {[1, 2, 3, 4].map((_, i) => (
                        <div
                            key={i}
                            className="bg-[#d9d9d9] h-[300px] rounded-lg shadow-md hover:scale-105 transition"
                        />
                    ))}
                </div>

                <button className="mt-10 text-[#22033c] font-semibold text-lg hover:underline">
                    Explore all Templates →
                </button>
            </section>

            {/* ✅ Single Footer */}
            {/* <Footer /> */}
        </div>
    );
};

export default Desktop4;
